// extracted by mini-css-extract-plugin
export default {"drag_handle":"Sortable_drag_handle__1VedA"};